import { Component, Input, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-company-logo-name',
  templateUrl: './company-logo-name.component.html',
  styleUrls: ['./company-logo-name.component.scss'],
})
export class CompanyLogoNameComponent implements OnInit {
  @Input() adOwner!: string;

  adOwnerData: any;

  constructor(private afs: AngularFirestore) {}

  ngOnInit(): void {
    this.afs
      .collection('users')
      .doc(this.adOwner)
      .valueChanges()
      .subscribe((res) => {
        this.adOwnerData = res;

        console.log('ppppppppppppppppppppp', this.adOwnerData);
      });
  }
}
